import { NgModule, ModuleWithProviders } from '@angular/core';
import { ReferenceGeneratorService } from './services/reference-generator.service';

@NgModule({
})
export class UtilityModule {
  constructor() { }
  static forRoot(): ModuleWithProviders<UtilityModule> {
    return {
      ngModule: UtilityModule,
      providers: [
        ReferenceGeneratorService,
      ],
    }
  }
}